import styled from "styled-components";

export const GeneralContainer = styled.div`
  overflow-x: auto;
`;

export const ContainerBack = styled.div`
  display: flex;
  background-color: white;
  width: auto;
  align-items: center;
`;

export const ContentBack = styled.div`
  display: grid;
  grid-template-columns: 7vw 8.2vw 12vw 1fr;
  align-items: center;
  @media only screen and (min-width: 769px) {
    grid-template-columns: 7vw 8vw 1fr;
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    grid-template-columns: 13vw 13vw 1fr;
  }
  @media only screen and (max-width: 480px) {
    grid-template-columns: 25vw 25vw 1fr;
  }
`;

export const Hr = styled.div`
  width: 108%;
  border: 1px solid
    ${({ theme, color }) => (color ? color : theme.secondaryGrayLightThree)};
`;

export const ButtonBack = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 56px;
  height: 25px;
  margin: 0px auto;
  text-align: left;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ContentText = styled.div`
  display: flex;
  justify-content: space-between;
  width: 90vw;
  margin: 0 0 1em 4em;
`;

export const SpanForm = styled.span`
  width: 110px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 600;
`;

export const SpanCaseId = styled.span`
  color: ${({ theme }) => theme.primary.purple};
  font-weight: 600;
`;

export const SpanCreationDate = styled.span`
  font-weight: 600;
  font-size: 12px;
`;

export const ContentPrincipalTitle = styled.div`
  margin: 1em;
  font-weight: 600;
`;

export const ContentCard = styled.div`
  display: flex;
  margin: 1em 2vw 1em 2vw;
  padding: 1em;
  background-color: ${({ theme }) => theme.neutral.gray[400]};
  flex-direction: column;
  border-radius: 5px;
`;

export const TitleCard = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.primary.purple};
`;

export const ContentHeaderCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ContentHr = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.5em 0;
`;

export const ContentFooterCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-direction: row;
`;

export const ContentLeftCard = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentRightCard = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextInternalCard = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: ${({ theme }) => theme.primary.purple};
`;

export const TextCountComments = styled.div`
  color: ${({ theme }) => theme.neutral.gray[2200]};
  font-size: 10px;
`;

export const TextDateCard = styled.div`
  color: ${({ theme }) => theme.neutral.gray[2200]};
  font-size: 10px;
`;

export const TextIdCard = styled.div`
  color: ${({ theme }) => theme.primary.purple};
  font-size: 15px;
`;
